import { render, staticRenderFns } from "./AuthTelegramDialog.vue?vue&type=template&id=64f897fe&scoped=true"
import script from "./AuthTelegramDialog.vue?vue&type=script&lang=js"
export * from "./AuthTelegramDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthTelegramDialog.vue?vue&type=style&index=0&id=64f897fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f897fe",
  null
  
)

export default component.exports